"use client";
import Link from "@casino/client/components/Link";

type Props = { game: GameFragment };

const GameProvider: FC<Props> = ({ game }) => {
  const provider = game.menuItem?.[0];
  if (!provider?.handle) {
    return null;
  }
  return (
    <Link
      href={`/providers/${provider.handle}`}
      prefetch={false}
      className="relative pointer-events-auto"
    >
      <p className="text-center text-[9px] font-semibold leading-3 text-white">
        {provider.name ?? "\u00A0"}
      </p>
    </Link>
  );
};

export default GameProvider;
